import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { AppStore } from '@navstation-portal/reporting/data-access/app';

export const authRedirectGuard: CanActivateFn = (
  route,
  state,
): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const appStore = inject(AppStore);
  const router = inject(Router);

  const urlWithoutParams = state.url.split('?')[0];
  if (urlWithoutParams === '/' || urlWithoutParams === '') {
    const vesselId = appStore.selectedVesselId() || authStore.defaultVesselId();
    return authStore.isLoggedIn()
      ? router.createUrlTree(['site', vesselId, 'crew-dashboard'])
      : router.createUrlTree(['login']);
  }

  return true;
};
